import { render, staticRenderFns } from "./am4charts-basic-chart.vue?vue&type=template&id=1544bb9a&"
import script from "./am4charts-basic-chart.vue?vue&type=script&lang=js&"
export * from "./am4charts-basic-chart.vue?vue&type=script&lang=js&"
import style0 from "./am4charts-basic-chart.vue?vue&type=style&index=0&id=1544bb9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports